<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn color="primary" rounded small @click="verifyUserBrowser" :loading="loading" :disabled="buttonDisabled">
            {{ buttonText }}
          </v-btn>
        </div>
      </template>
      <div>
        <div v-if="!buttonDisabled">
          Entrar na sala de atendimento
        </div>
        <div v-else>
          Você poderá realizar seu atendimento no dia {{ dateAppointment }} das {{ enterTimeStart }} até
          {{ enterTimeLimit }}
        </div>
      </div>
    </v-tooltip>

    <FormDadosAtendimento v-if="dialog" @dados-confirmados="enterOnQueue" />
  </div>
</template>

<script>
import { ptBR } from 'date-fns/locale'
import meetingService from '@/services/meeting'
import FormDadosAtendimento from '../AtendimentoVirtual/FormDadosAtendimento.vue'
import { format } from 'date-fns'

export default {
  name: 'AgendamentoCardButton',
  props: {
    dtHorarioMedico: {
      required: true,
      type: String
    },
    horarioMedico: {
      required: true,
      type: String
    },
    idAsoMeetingRoom: {
      type: String
    },
    statusAsoMeetingRoom: {
      type: String
    },
    idAso: {
      required: true,
      type: Number
    },
    datetimeHorarioMedico: {
      required: true,
      type: String
    }
  },
  components: {
    FormDadosAtendimento
  },
  data() {
    return {
      buttonText: 'Acessar consulta',
      minutesBeforeAppointment: 10,
      minutesAfterAppointment: 30,
      agendamentoDate: null,
      hintText: '',
      loading: false,
      dialog: false,
      buttonDisabled: true,
      timer: false,
      supportedBrowsersMobile: [
        {
          nome: 'Google Chrome',
          test: ua => ua.includes('Chrome')
        },
        {
          nome: 'Microsoft Edge',
          test: ua => ua.includes('Edg')
        }
      ]
    }
  },
  computed: {
    dateAppointment() {
      const appointmentDate = new Date(this.datetimeHorarioMedico)
      return format(appointmentDate, 'dd/MM/yyyy', { locale: ptBR })
    },
    enterTimeStart() {
      const originalDate = new Date(this.datetimeHorarioMedico)
      const dateStart = new Date(originalDate.getTime() - this.minutesBeforeAppointment * 60000)
      return dateStart.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
    },
    enterTimeLimit() {
      const originalDate = new Date(this.datetimeHorarioMedico)
      const dateStart = new Date(originalDate.getTime() + this.minutesAfterAppointment * 60000)
      return dateStart.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
    }
  },
  methods: {
    verifyUserBrowser() {
      if (this.isIOS() && !this.isIOSVersionSupported()) {
        this.showBrowserErrorMessage()
      } else if (this.isMobile() && !this.isMobileBrowserSupported()) {
        this.showBrowserErrorMessage()
      } else {
        this.dialog = true
      }
    },
    isWithinTimeRange() {
      const currentDate = new Date()
      const appointmentDate = new Date(this.datetimeHorarioMedico)
      const differenceInMilliseconds = appointmentDate - currentDate
      const differenceInMinutes = differenceInMilliseconds / (1000 * 60)

      if (differenceInMinutes < this.minutesBeforeAppointment && differenceInMinutes > -this.minutesAfterAppointment) {
        this.buttonDisabled = false
        return true
      } else {
        this.buttonDisabled = true
        return false
      }
    },
    async enterOnQueue() {
      if (!this.disabled) {
        try {
          this.loading = true
          const { data } = await meetingService.enterOnQueue(this.idAso, this.idAsoMeetingRoom)
          this.$router.push({ name: 'fila-atendimento', params: { idAsoMeetingRoom: data.idAsoMeetingRoom } })
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
          this.dialog = false
        } finally {
          this.loading = false
        }
      }
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    isIOSVersionSupported() {
      const versionMatch = navigator.userAgent.match(/OS (\d+)_/)
      if (versionMatch && versionMatch[1]) {
        const version = parseFloat(versionMatch[1])
        return version >= 13.0
      }
      return false
    },
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /BlackBerry/i,
        /Windows Phone/i
      ]

      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
      })
    },
    isMobileBrowserSupported() {
      const userAgent = navigator.userAgent
      const isSupported = this.supportedBrowsersMobile.find(browser => browser.test(userAgent))
      return !!isSupported
    },
    showBrowserErrorMessage() {
      this.$showErrorMessage(
        'Esta funcionalidade não é suportada neste navegador. Por favor, utilize a versão mais recente do Microsoft Edge ou Google Chrome.'
      )
      this.$router.push({ name: 'dashboard' })
    }
  },
  mounted() {
    this.isWithinTimeRange()
    this.timer = setInterval(this.isWithinTimeRange, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped></style>
